<ion-app [dir]="direction" >
  <ion-split-pane contentId="main-content">
    <ion-menu 
      contentId="main-content" 

      color="primary"
    >
      <ion-content  class="ion-padding-bottom ion-margin-bottom">
        
        <ion-button
            *ngIf=" menuLayout === 'proofing' "
            (click)="parentBack()"
            color="medium"
            size="medium"
        > < Back</ion-button>
        <ion-list id="inbox-list" *ngIf=" menuLayout === 'app' " >
 
          <ion-list-header *ngIf="user ">
            <ion-icon 
            src="./assets/icons/ionicons/person-circle.svg"
             class=""></ion-icon>
            {{user.first_name}} {{user.last_name}}</ion-list-header>
          <ion-note  *ngIf="user">{{user.email}}</ion-note>

        </ion-list>

        <ion-menu-toggle auto-hide="false">

          <ion-list>
            <ion-item
        
              lines="none" 
              detail="false" 
              routerLink="/language"
        

            >
            <ion-icon 
              color="white" 
              src="./assets/icons/ionicons/globe.svg"
             
              slot="start" ></ion-icon> {{language.title}} ({{language.locale}})
            </ion-item>
          </ion-list>

          <ion-list class="dynamic-list"
            *ngFor="let list of menuLinks; let i = index"  
          >
            <ion-list-header *ngIf="list.title">
              {{list.title}}
            </ion-list-header>
              <ion-item
                *ngFor="let link of list.links; let j = index" 
                lines="none" 
                detail="false" 
                (click) = "menuClick( link.method, link.args )"
                class="ion-activatable"

              >
              <ion-icon slot="start"  
          
                [src]="'./assets/icons/ionicons/'+link.icon+'.svg'"
                color="{{link.color? link.color: 'white'}}"></ion-icon>
                {{link.title}}
              </ion-item>
        
          </ion-list>


          
            <ion-grid 
            *ngIf=" menuLayout === 'app' "
            class="ion-margin-top ion-margin-bottom ion-padding-top ion-padding-bottom">
              <ion-row>
                <ion-col>
                  <ion-button
                    *ngIf="user"
                    (click)="signOutBtn()"
                    color="medium"
                    expand="block"
                    size="medium"
                    class="ion-margin-top ion-margin-bottom"
                  >{{strings['global.app.Log out']}}</ion-button>
                </ion-col>
              </ion-row>
              
            </ion-grid>

            <ion-card 
              *ngIf=" menuLayout === 'app'  && ( showInstallButton && installOnThisUrl) " 
              (click)= "pwaInstallClick()" 
              class="pwaInstall"
              
            >
              <ion-card-content>
                <ion-grid>
                  <ion-row class="pwaInstallBtn">
                    <ion-col size="4">
                      <img src="./assets/icons/icon-72x72.png" alt="app icon" />
                    </ion-col>
                    <ion-col class="ion-text-center">
                      <ion-button >Install Web App</ion-button>
                    </ion-col>
                  </ion-row>
                </ion-grid>
                <div class="installBtns">
                </div>
              </ion-card-content>
       
            </ion-card>
         
          

        


        </ion-menu-toggle>



        
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"  ></ion-router-outlet>
  </ion-split-pane>
  
  <jeep-sqlite *ngIf="isWeb && isLocalHost"></jeep-sqlite>
  <jeep-sqlite *ngIf="isWeb && !isLocalHost"  autoSave="true" wasmPath="/app/assets" ></jeep-sqlite>
</ion-app>
